import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Term_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_MODEL_TERM_ID:       {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Model Term Id',       columnResourceName: 'colId',                     alignment: HorizAlignment.Left},  domainOptions: {} },
    TERM_ID:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Term Id',          columnResourceName: 'colId',                     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TERM_NAME:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Term Name',        columnResourceName: 'colModelTermName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMMENTS:                   {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Notes',                   columnResourceName: 'colComments',               alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TERM_TYPE:      {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Term Type',     columnResourceName: 'colPredNumType',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    DELETED_IND:                {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Deleted Ind',                columnResourceName: 'colDeletedInd',             alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_DT:                 {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',               columnResourceName: 'colDeletedDate',            alignment: HorizAlignment.Left}, domainOptions: {}}
};

const ModelTermSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_MODEL_TERM_ID',
        id_ui: 'TERM_ID',
        name:  'TERM_NAME'

    },

    searchProviderFields: vUI_Model_Term_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Term_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ModelTermSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ModelTermSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'TERM_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'TERM_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'TERM_ID', 'TERM_NAME', 'TERM_TYPE', 'COMMENTS',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelTermSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelTermSearch: ISearch = {
    searchName: "Find Model Term",
    renderOptions: {ui5ResourceId: "ModelTermSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelTermSearchProfileByName]
};

PAEnvironment.registerBusinessObjectSearch("ModelTermBO", "ModelTerm", ModelTermSearch, "Model Term Search")


export {ModelTermSearch}